<template>
  <v-container
    id="dashboard"
    tag="section"
    fluid
  >
    <v-row justify="center">
      <v-dialog
        v-model="dialog"
        max-width="290"
      >
        <v-card>
          <v-card-title
            id="input-novo-relatorio"
            class="headline"
          >
            Novo relatório
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-select
                  v-model="dialogTiporelatorio"
                  name="dialogTiporelatorio"
                  label="Tipo de Relatório"
                  :items="itensTipoRelatorio"
                  filled
                />
              </v-row>
              <v-row>
                <v-select
                  v-if="dialogTiporelatorio == 'Usar Modelo'"
                  v-model="dialogGrupoRelatorio"
                  name="dialogTiporelatorio"
                  label="Grupo"
                  :items="modelosGruposDialog"
                  item-text="title"
                  item-value="id"
                  return-object
                  filled
                  @change="getModelosTemplatesDialogByGroup(dialogGrupoRelatorio.id)"
                />
              </v-row>
              <v-row>
                <v-select
                  v-if="dialogGrupoRelatorio && dialogTiporelatorio == 'Usar Modelo'"
                  v-model="dialogTipoRelatorioModelo"
                  name="dialogTipoRelatorioModelo"
                  :items="modelosTemplateDialog"
                  item-text="title"
                  item-value="id"
                  return-object
                  label="Template"
                  filled
                />
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="green darken-1"
              text
              @click="dialog = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="green darken-1"
              @click="dialogDestiny"
            >
              Prosseguir
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row
      justify="center"
      align="center"
    >
      <v-col cols="8">
        <relatorios-navigation-tabs 
          :relatorios-modelos="modelosChildren"
          :active-slider-color="!visualizar.ativo"
          @goToFirstPage="goToTableFirstPage()"
          @click:triggered="visualizar = {ativo : false, id: null}"
          @actionVisualizarTriggered="goToVisualizar($event.relatorio_id)"
        />
      </v-col>
    </v-row>
    <v-row class="mt-n9">
      <v-col cols="12">
        <v-scroll-x-transition hide-on-leave>
          <relatorios-data-table 
            ref="relatoriosDataTable"
            :items="tableLines"
            :title="tableTitle"
            :loading="loading"
            @recharge="chargeTableDecision(tipoListaConsulta)"
            @opendialog="opendialog"
            @actionVisualizarTriggered="goToVisualizar($event.relatorio_id)"
            @switchConsutasInternasChanged="consultasInternas = $event"
            @switchProcessamentosExpirados="processamentosExpirados = $event, getAllConsultas()"
          />
        </v-scroll-x-transition>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import RelatoriosService from '@/services/RelatoriosService';
import tourMixins from '@/mixins/tourMixins';
import pusherMixins from '@/mixins/pusherMixins';

export default {

  components: {
    RelatoriosNavigationTabs: () => import('@/components/relatorios/RelatoriosNavigationTabs'),
    RelatoriosDataTable: () => import('@/components/relatorios/RelatoriosDataTable'),
    ViewVisualizarRelatorio: () => import('@/views/relatorios/Visualizar')
  },
  mixins: [pusherMixins, tourMixins],

  data () {
    return {
      modelosChildren: [],
      tableTitle: 'Relatórios',
      consultasInternas: false,
      processamentosExpirados: false,
      tableLines: [],
      loading: false,
      dialog: false,
      dialogTiporelatorio: 'Padrão',
      dialogGrupoRelatorio: '',
      dialogTipoRelatorioModelo: '',
      modelosTemplateDialog: [],
      arrTour: [
        {
          element: '#tab-historico',
          intro: 'Selecionando este menu você poderá acessar todas as consultas e relatórios cadastrados.',
          scrollTo: 'tooltip',
          position: 'bottom'
        },
        {
          element: '#tab-favoritos',
          intro: 'Selecionando esta opção você poderá acessar os relatórios que você definir como seus FAVORITOS.',
          scrollTo: 'tooltip',
          position: 'bottom'
        },
        {
          element: '#tab-tabelas-regulatorias',
          intro: 'Aqui você acessa tabelas de dados do MPCSE, índices de inflação, dentre outros.',
          scrollTo: 'tooltip',
          position: 'bottom'
        },
        {
          element: '#tab-modelos',
          intro: 'Nesta opção você cria relatórios a partir de modelos predefinidos. Você pode solicitar novos modelos através do nosso chat.',
          scrollTo: 'tooltip',
          position: 'bottom'
        },
        {
          element: '#btn-novo-relatorio',
          intro: 'Clicando sobre este botão você poderá criar novas consultas ou relatórios modelo.',
          scrollTo: 'tooltip',
          position: 'right'
        },
        {
          element: '#relatorios-historico-search',
          intro: 'Neste campo você poderá pesquisar consultas e relatórios.',
          scrollTo: 'tooltip',
          position: 'bottom'
        },
        {
          element: '#action-download-rel',
          intro: 'Clicando neste ícone você poderá fazer o download em .XLSX do resultado da sua consulta/relatório.',
          scrollTo: 'tooltip',
          position: 'left'
        }, /* Caso algum dia for relatado algum problema com resoluções menores trocar position por auto */
        {
          element: '#action-edit-rel',
          intro: 'Clicando neste ícone você poderá editar seu relatório, incluindo, alterando ou excluindo campos e filtros.',
          scrollTo: 'tooltip',
          position: 'left'
        }, /* Caso algum dia for relatado algum problema com resoluções menores trocar position por auto */
        {
          element: '#action-favoritar-rel',
          intro: 'Clicando neste ícone você marca este relatório como favorito, podendo acessá-lo mais rapidamente através do menu superior "FAVORITOS".',
          scrollTo: 'tooltip',
          position: 'left'
        }, /* Caso algum dia for relatado algum problema com resoluções menores trocar position por auto */
        {
          element: '#action-more-rel',
          intro: 'Aqui você acessa outras opções para seu relatório, como executá-lo novamente, duplicá-lo ou deletá-lo.',
          scrollTo: 'tooltip',
          position: 'left'
        } /* Caso algum dia for relatado algum problema com resoluções menores trocar position por auto */
      ],
      visualizar: {ativo: false, relatorio_id: null}
    };
  },

  computed: {
    modelosGruposDialog: function () {
      let array = [];
      this.modelosChildren.forEach(element => {
        array.push(
          {
            id: element.id,
            title: element.title
          }
        );
      });
      return array;
    },

    tipoListaConsulta() {
      return this.$store.getters.getTipoListaConsulta;
    },

    itensTipoRelatorio() {
      return !this.userIsAdmin ? ['Padrão', 'Usar Modelo'] : ['Padrão', 'Usar Modelo', 'Customizado'];
    },

    userIsAdmin() {
      return this.$store.getters.userIsAdmin;
    }
  },

  watch: {
    tipoListaConsulta(newValue) {
      this.chargeTableDecision(newValue);   
    },

    consultasInternas() {
      this.chargeTableDecision(this.tipoListaConsulta);
    }
  },

  mounted () {
    this.subscribe();
    this.getGruposRelatorios();
    this.chargeTableDecision(this.tipoListaConsulta);
  },

  methods: {
    goToVisualizar(relatorioId) {
      this.$router.push(`visualizar/${relatorioId}`);
    },
      
    subscribe () {
      this.pusherChannel.bind('refreshConsultas', () => {
        this.chargeTableDecision(this.tipoListaConsulta);
      });
    },
      
    chargeTableDecision(value) {
      switch(value) {
      case 'favoritos':
        this.getFavoritosConsultas();
        break;
      case '':
      case 'historico':
        this.getAllConsultas();
        break;
        //default será o click em algum dos relatorios modelo e o atributo do vuex terá o id do relatorio pai
      default:
        this.getRelatoriosModelo();
      }
    },

    dialogDestiny () {
      if(this.dialogTiporelatorio === 'Padrão') {
        this.$router.push('edit');
      } else if (this.dialogTiporelatorio === 'Customizado' && this.userIsAdmin) {
        this.$router.push('customizado/edit');
      } else if(this.dialogTipoRelatorioModelo) {
        this.$router.push('modelo/'+this.dialogTipoRelatorioModelo.id);
      }

      this.dialog = false;

    },

    opendialog () {
        
      switch(this.tipoListaConsulta) {
      case '':
        break;
      case 'favoritos':
      case 'historico':
        this.dialogTiporelatorio = 'Padrão';
        break;
      default:

        RelatoriosService.getConsultaModelo(this.tipoListaConsulta)
          .then(response => {
            this.dialogGrupoRelatorio = response.data.consultaModelo.grupo_relatorio_id;
            this.getModelosTemplatesDialogByGroup(this.dialogGrupoRelatorio);
            this.dialogTipoRelatorioModelo = {};
            this.dialogTipoRelatorioModelo.id = this.tipoListaConsulta;
          })
          .catch(error => console.log(error));
        this.dialogTiporelatorio = 'Usar Modelo';
            
        break;
      }
      this.dialog = true;
        
    },

    getModelosTemplatesDialogByGroup (grupo) {
      let array = [];
      this.modelosChildren.forEach(element => {
        if (element.id === grupo) {
          element.children.forEach(element2 => {
            array.push(
              {
                id: element2.id,
                title: element2.title
              }
            );
          });
        }
      });
      this.modelosTemplateDialog =  array;
    },

    getRelatoriosModelo () {
      this.loading = true;
      this.tableLines = [];

      RelatoriosService.getConsultasByModeloId(this.tipoListaConsulta)
        .then(response => {
          this.tableLines = response.data.consultas;
          this.iniciarTourPagina();
        })
        .catch(error => console.log(error))
        .finally(() => this.loading = false);
    },

    getAllConsultas () {
      this.loading = true;
      this.tableLines = [];

      RelatoriosService.getRelatoriosConsultas(this.consultasInternas, this.processamentosExpirados)
        .then(response => {
          this.tableLines = response.data.consultas;
          this.iniciarTourPagina();
        })
        .catch(error => console.log(error))
        .finally(() => this.loading = false);
    },

    getFavoritosConsultas () {
      this.loading = true;
      this.tableLines = [];

      RelatoriosService.getRelatoriosFavoritosUsuario(this.consultasInternas)
        .then(response => {
          this.tableLines = response.data.consultas;
          this.iniciarTourPagina();
        })
        .catch(error => console.log(error))
        .finally(() => this.loading = false);
    },

    getGruposRelatorios () {
      RelatoriosService.getRelatoriosModelosGroups()
        .then(response => {
          let obj = {};
          response.data.gruposRelatorios.forEach(element => {
            obj = {
              id: element.id,
              title: element.titulo,
              children: []
            };

            element.relatorios.forEach(element2 => {
              obj.children.push(
                {
                  title: element2.nome,
                  id: element2.id,
                  tipo: element2.id
                }
              );    
            });
            
            this.modelosChildren.push(obj);
          });
        })
        .catch(error => {
          console.log(error);
          this.$toast.error('Erro ao recuperar relatorios modelo.', '', {position:'topRight'});
        });
    },
      
    goToTableFirstPage() {
      this.$refs.relatoriosDataTable.page = 1;
    },

    iniciarTourPagina() {
      if (this.tourFuncCalled) return;
        
      let arrTourFormatted = this.tableLines.length ? this.arrTour : this.arrTour.splice(0, 6);
      this.iniciarTour(arrTourFormatted);
    }
  }
};
</script>